import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createOrientacionesSchema = yup.object({
  nombre: yup
    .string()
    .required(DEFAULT_MESSAGES.REQUIRED)
    .test(
      "is-not-blank",
      "El nombre no puede estar vacío o contener solo espacios.",
      value => !!value && value.trim().length > 0 && /[A-Za-z0-9]/.test(value)
    ),
});